import React from 'react'
import {
    ListItem,
    ListItemButton,
    ListItemText,
    Tooltip,
    Box,
    CircularProgress,
} from '@mui/material'
import { useTranslation } from 'react-i18next'

interface ResumeListItemProps {
    item: { key: string; label: string }
    mostRecentStory: { storyId: string; storyTitle: string } | null
    progressLoading: boolean
    isLessonPage: () => boolean
    onResumeClick: () => void
    llmLocked?: boolean
}

export const ResumeListItem: React.FC<ResumeListItemProps> = ({
    item,
    mostRecentStory,
    progressLoading,
    isLessonPage,
    onResumeClick,
    llmLocked = false,
}) => {
    const { t } = useTranslation()
    const isResumeEnabled = !!mostRecentStory && !llmLocked
    const resumeAriaLabel = mostRecentStory
        ? t('navigation:resume.aria', { title: mostRecentStory.storyTitle })
        : t('navigation:resume.loading')
    const tooltipTitle = llmLocked
        ? t('errors:llmQuota.lockTooltip')
        : !mostRecentStory
          ? t('navigation:resume.tooltip.empty')
          : ''

    return (
        <ListItem key={item.key} disablePadding>
            <Tooltip title={tooltipTitle} disableHoverListener={!tooltipTitle}>
                <Box sx={{ width: '100%' }}>
                    <ListItemButton
                        onClick={onResumeClick}
                        disabled={!isResumeEnabled}
                        aria-disabled={!isResumeEnabled}
                        aria-label={resumeAriaLabel}
                        selected={isLessonPage()}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            color: isResumeEnabled ? 'text.primary' : 'text.disabled',
                            fontWeight: 400,
                            '&:hover': {
                                backgroundColor: isResumeEnabled ? 'action.hover' : 'transparent',
                            },
                        }}
                    >
                        {progressLoading ? <CircularProgress size={16} color="inherit" /> : null}
                        <ListItemText primary={item.label} />
                    </ListItemButton>
                </Box>
            </Tooltip>
        </ListItem>
    )
}
